// components/forms/TextArea.tsx
import { useAppTheme } from "@/hooks/useAppTheme";
import React, { useState } from "react";
import {
  StyleSheet,
  Text,
  TextInput,
  TextInputProps,
  View,
} from "react-native";

export interface TextAreaProps extends TextInputProps {
  label?: string;
  error?: string;
  containerStyle?: object;
  labelStyle?: object;
  inputStyle?: object;
  errorStyle?: object;
  numberOfLines?: number;
}

export const TextArea: React.FC<TextAreaProps> = ({
  label,
  error,
  containerStyle,
  labelStyle,
  inputStyle,
  errorStyle,
  numberOfLines = 4,
  ...textInputProps
}) => {
  const { colors, spacing, borderRadius, typography } = useAppTheme();
  const [isFocused, setIsFocused] = useState(false);

  const styles = StyleSheet.create({
    container: {
      marginBottom: spacing.lg,
    },
    label: {
      ...typography.label,
      color: colors.text,
      marginBottom: spacing.xs,
    },
    input: {
      borderWidth: 1,
      borderColor: colors.border,
      borderRadius: borderRadius.md,
      padding: spacing.md,
      ...typography.input,
      color: colors.text,
      textAlignVertical: "top",
      backgroundColor: colors.background,
    },
    inputFocused: {
      borderColor: colors.primary,
      borderWidth: 2,
    },
    inputError: {
      borderColor: colors.danger,
    },
    error: {
      ...typography.error,
      color: colors.danger,
      marginTop: spacing.xs,
    },
  });

  return (
    <View style={[styles.container, containerStyle]}>
      {label && <Text style={[styles.label, labelStyle]}>{label}</Text>}
      <TextInput
        multiline
        numberOfLines={numberOfLines}
        style={[
          styles.input,
          isFocused && styles.inputFocused,
          error && styles.inputError,
          inputStyle,
        ]}
        placeholderTextColor={colors.placeholder}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        {...textInputProps}
      />
      {error && <Text style={[styles.error, errorStyle]}>{error}</Text>}
    </View>
  );
};
